module.exports = __webpack_public_path__ + "static/media/needle.e599cca0.svg";